import Nullstack from 'nullstack';
export default function IconBuildingBridge({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-bridge",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "5",
    x2: "6",
    y2: "19"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "5",
    x2: "18",
    y2: "19"
  }), "   ", Nullstack.element("line", {
    x1: "2",
    y1: "15",
    x2: "22",
    y2: "15"
  }), "   ", Nullstack.element("path", {
    d: "M3 8a7.5 7.5 0 0 0 3 -2a6.5 6.5 0 0 0 12 0a7.5 7.5 0 0 0 3 2"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "10",
    x2: "12",
    y2: "15"
  }), " ");
}